import { z } from 'zod';
import { useRoutingRulesData } from '../queries';
import { targetBillSchema } from './targetBillSchema';
import { itemsAndConditionsSchema } from './itemsAndConditionsSchema';
import { timingSchema } from './timingSchema';

export const useCreateRoutingRuleSchema = (routingRuleId?: string) => {
    const { data: routingRulesData } = useRoutingRulesData();

    const otherRoutingRules = routingRulesData?.routingRules?.filter((rule) => rule.id !== routingRuleId);
    const existingNames = otherRoutingRules?.map((rule) => rule.name ?? '') ?? [];

    return timingSchema(existingNames).merge(itemsAndConditionsSchema.merge(targetBillSchema));
};

export type RoutingRuleFormValues = z.infer<ReturnType<typeof useCreateRoutingRuleSchema>>;
